import * as THREE from 'three';
import { gsap } from "gsap";
import {get_distance,degrees_to_radians,radians_to_degrees} from './Utils.js';
import {EventEmitter} from '@billjs/event-emitter';


export default class MobilePadController extends EventEmitter{

  constructor(){
    super();
    this.padEl = document.getElementById("mobile-pad");
    this.innerCircle = document.querySelector(".inner-circle");
    this.onDownRotation = 0;
    this.gamePadActive = false;
  }

  init(myFlamingo,physicsCharacter){
    this.myFlamingo = myFlamingo;
    this.physicsCharacter = physicsCharacter;
    this.physicsCharacter.angleBase = degrees_to_radians(15);

    this.padEl.addEventListener('pointerdown', function(e){this.onPointerDown(e)}.bind(this));
    window.addEventListener('pointerup', function(e){this.onPointerUp(e)}.bind(this));
    this.padEl.addEventListener('pointermove', function(e){this.onPointerMove(e)}.bind(this));

    this.padEl.addEventListener('click', function(e){
      console.log("click mobile-pad");
      let bb = this.padEl.getBoundingClientRect();
      let center = {x: bb.left + bb.width/2,y:bb.top+bb.height/2};
      let angle = this.getPadAngle(e);
      let d = get_distance(e.clientX,e.clientY,center.x,center.y);


      this.doMobileControl(e,angle,bb,center,d);

      if(!this.didFirstMove){
        this.didFirstMove = true;
        this.fire("first_move");
      }

      //this.onPointerDown(e)
    }.bind(this));

    this.padEl.addEventListener('touchmove', function(e){
      e.preventDefault();
    });

    this.padEl.addEventListener('touchstart', function(e){
      console.log("touchstart mobile-pad");
      this.gamePadActive = true;
      e.preventDefault();
    }.bind(this));

  }

  update(){}

  onPointerDown(e){

    this.fire("pointer_down");

    e.stopPropagation();
    e.preventDefault();

    this.isDown = true;
    let bb = this.padEl.getBoundingClientRect();
    let center = {x: bb.left + bb.width/2,y:bb.top+bb.height/2};
    let angle = this.getPadAngle(e);
    let d = get_distance(e.clientX,e.clientY,center.x,center.y);

    this.doMobileControl(e,angle,bb,center,d);
    this.updateInnerCircle(angle,bb,center,d);

    this.myFlamingo.isMoving();


    this.innerCircle.classList.add("active");

    if(!this.didFirstMove){
      this.didFirstMove = true;
      this.fire("first_move");
    }

    this.fire("did_move");

  }

  onPointerUp(e){
    if(e.target === this.padEl){
      this.gamePadActive = false;
    }

    if(this.isDown && (e.target == this.padEl || e.target == this.innerCircle)){

      this.isDown = false;
      this.physicsCharacter.keyHash['ArrowUp'] = false;
      this.myFlamingo.keyHash['ArrowUp'] = false;
      this.physicsCharacter.keyHash['ArrowDown'] = false;
      this.myFlamingo.keyHash['ArrowDown'] = false;
      // this.physicsCharacter.keyHash[' '] = false;
      // this.myFlamingo.keyHash[' '] = false;

      this.physicsCharacter.keyHash['ArrowRight'] = false;
      this.physicsCharacter.keyHash['ArrowLeft'] = false;
      this.myFlamingo.keyHash['ArrowRight'] = false;
      this.myFlamingo.keyHash['ArrowLeft'] = false;

      if(this.myFlamingo.mode == "moving" && this.myFlamingo.keyHash[' '] == false){
        this.myFlamingo.mode = "pause_moving";
      }
      this.innerCircle.classList.remove("active");
      this.innerCircle.style.left = "25%";
      this.innerCircle.style.top = "25%";

    }


  }

  onPointerMove(e){
    e.stopPropagation();
    e.preventDefault();
    // let angle = Math.atan2( )
    if(this.isDown){

      let bb = this.padEl.getBoundingClientRect();
      let center = {x: bb.left + bb.width/2,y:bb.top+bb.height/2};
      let angle = this.getPadAngle(e);
      let d = get_distance(e.clientX,e.clientY,center.x,center.y);

      this.doMobileControl(e,angle,bb,center,d);
      this.updateInnerCircle(angle,bb,center,d);
    }

  }

  doMobileControl(e,angle,bb,center,d){
    //Math.atan2(e.clientY - center.y, e.clientX - center.x);

    let flyLimit = bb.width/4;
    let angleMin = degrees_to_radians(45);

    // if( e.clientY < center.y){
      this.physicsCharacter.setKeyHash('ArrowUp');
      this.myFlamingo.keyHash['ArrowUp'] = true;

      this.physicsCharacter.keyHash['ArrowDown'] = false;
      this.myFlamingo.keyHash['ArrowDown'] = false;

      let deg = radians_to_degrees(Math.atan2(e.clientY - center.y, e.clientX - center.x))+180;

      let speedMax = 50.0;

      if( e.clientX < center.x && (deg < 60 || deg > 315) ){
        this.physicsCharacter.keyHash['ArrowLeft'] = true;
        this.physicsCharacter.keyHash['ArrowRight'] = false;
        let angleDist = Math.min(Math.abs(0-deg),Math.abs(360-deg));
        this.physicsCharacter.rotationSpeedMax = degrees_to_radians(60-angleDist)*speedMax;
        let speedDamp = 1 - (60-angleDist)/60;
        this.physicsCharacter.maxSpeed = 3*speedDamp;
     }else if( e.clientX > center.x && ((deg > 120 && deg < 225 ) )){
       this.physicsCharacter.keyHash['ArrowRight'] = true;
       this.physicsCharacter.keyHash['ArrowLeft'] = false;
       let angleDist = Math.abs(180-deg);
       this.physicsCharacter.rotationSpeedMax = degrees_to_radians(60-angleDist)*speedMax;
       let speedDamp = 1 - (60-angleDist)/60;
       this.physicsCharacter.maxSpeed = 6*speedDamp;
      }else{
       this.physicsCharacter.keyHash['ArrowLeft'] = false;
       this.physicsCharacter.keyHash['ArrowRight'] = false;
       this.physicsCharacter.maxSpeed = 6;

       if( e.clientY < center.y ){
         this.physicsCharacter.keyHash['ArrowUp'] = true;
         this.myFlamingo.keyHash['ArrowUp'] = true;
         this.physicsCharacter.keyHash['ArrowDown'] = false;
         this.myFlamingo.keyHash['ArrowDown'] = false;
       }else{
         this.physicsCharacter.keyHash['ArrowUp'] = false;
         this.myFlamingo.keyHash['ArrowUp'] = false;
         this.physicsCharacter.keyHash['ArrowDown'] = true;
         this.myFlamingo.keyHash['ArrowDown'] = true;
       }
      }
  }

  updateInnerCircle(angle,bb,center,d){

    let bbCircle = this.innerCircle.getBoundingClientRect();
    d = Math.min(bb.width/2,d);
    let posX = center.x + d * Math.sin(-angle) - bb.left;
    let posY =  center.y - d * Math.cos(-angle) - bb.top;
    this.innerCircle.style.left = (posX - (bbCircle.width/2)) + "px";
    this.innerCircle.style.top = (posY - bbCircle.height/2) + "px";

  }

  getPadAngle(e){
    let bb = this.padEl.getBoundingClientRect();
    let center = {x: bb.left + bb.width/2,y:bb.top+bb.height/2};
    let angle = Math.atan2(e.clientY - center.y, e.clientX - center.x);

    angle += (Math.PI/2);
    return -angle;
  }

  update(){
    // let bb = this.padEl.getBoundingClientRect();
    // let bbCircle = this.innerCircle.getBoundingClientRect();
    // if(bbCircle.left - )
  }

  doJumpOn(){
    if(this.myFlamingo){
      this.myFlamingo.keyHash[' '] = true;
    }

    if( this.physicsCharacter && this.myFlamingo.isMoving() ){
      this.physicsCharacter.setKeyHash(' ');
    }
  }

  doJumpOff(){
    if(this.myFlamingo){
      this.myFlamingo.keyHash[' '] = false;
    }

    if( this.physicsCharacter ){
        this.physicsCharacter.keyHash[' '] = false;
    }


  }

}
